import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import cn from 'classnames';
import { DEFAULT_ASPECT_RATIO } from "../constants";
import { jsx as _jsx } from "react/jsx-runtime";
var getRatioValues = function getRatioValues(_ref) {
  var _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'landscape' : _ref$orientation,
    aspectRatio = _ref.aspectRatio;
  var _DEFAULT_ASPECT_RATIO = DEFAULT_ASPECT_RATIO.split(':'),
    _DEFAULT_ASPECT_RATIO2 = _slicedToArray(_DEFAULT_ASPECT_RATIO, 2),
    defaultRawW = _DEFAULT_ASPECT_RATIO2[0],
    defaultRawH = _DEFAULT_ASPECT_RATIO2[1];
  var defaultW = Number(defaultRawW);
  var defaultH = Number(defaultRawH);

  // We will keep the default landscape ratio for portrait orientation to avoid exceeding the container height
  if (orientation === 'portrait' || !aspectRatio) {
    return {
      W: defaultW,
      H: defaultH
    };
  }
  var _aspectRatio$split = aspectRatio.split(':'),
    _aspectRatio$split2 = _slicedToArray(_aspectRatio$split, 2),
    rawW = _aspectRatio$split2[0],
    rawH = _aspectRatio$split2[1];
  return {
    W: Number(rawW) || defaultW,
    H: Number(rawH) || defaultH
  };
};

/* This component doesn't use local contexts because it can be directly imported from outside */
var Ratio = function Ratio(_ref2) {
  var poster = _ref2.poster,
    orientation = _ref2.orientation,
    aspectRatio = _ref2.aspectRatio,
    className = _ref2.className,
    style = _ref2.style;
  var backgroundStyles = poster ? {
    backgroundImage: "url(".concat(poster, ")"),
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  } : undefined;
  var _getRatioValues = getRatioValues({
      orientation: orientation,
      aspectRatio: aspectRatio
    }),
    W = _getRatioValues.W,
    H = _getRatioValues.H;
  return /*#__PURE__*/_jsx("div", {
    className: cn('cp-ratio w-full bg-gray-main-dark-mode', className),
    style: _objectSpread(_objectSpread({
      paddingTop: "".concat(H / W * 100, "%")
    }, backgroundStyles), style)
  });
};
export default Ratio;